import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/system/authentication/services/configuration", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(JSONbody, requestOptions) {
  return __request__("POST", "/system/authentication/services/configuration", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
